import {
  TrailerType,
  TrailerTypeAbbreviations,
  TrailerTypeLabels,
} from '@trucksmarter/shared';
import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import { EMPTY_VALUE_PLACEHOLDER } from '~/app/_ui/shared/text-placeholders';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';

interface Props {
  className?: string;
  trailerTypes: TrailerType[] | null;
  compact?: boolean;
}

export default function TrailerTypesCell({ className, ...props }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <TrailerTypesCellContent {...props} />
    </DallasTableDataCell>
  );
}

export function TrailerTypesCellContent({
  className,
  trailerTypes,
  compact = false,
}: Props) {
  return trailerTypes?.length ? (
    <ul className={className}>
      {Array.from(new Set(trailerTypes)).map((trailerType, i) => (
        <li key={i}>
          <DallasText variant="captionL">
            {compact ? (
              <abbr title={TrailerTypeLabels[trailerType]}>
                {TrailerTypeAbbreviations[trailerType]}
              </abbr>
            ) : (
              `${
                TrailerTypeAbbreviations[trailerType]
                  ? `(${TrailerTypeAbbreviations[trailerType]}) `
                  : ''
              }${TrailerTypeLabels[trailerType]}`
            )}
          </DallasText>
        </li>
      ))}
    </ul>
  ) : (
    <DallasText variant="captionL">{EMPTY_VALUE_PLACEHOLDER}</DallasText>
  );
}
